var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dailyStats.data)?_c('v-chart',{attrs:{"options":_vm.dailyChartOptions,"theme":_vm.getChartTheme,"autoresize":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }